export enum AuthorizationPlatformAccessOperation {
    create = "c1c3bd3f-d9e2-442f-9ee4-7771e4fb8197",
    read = "1f4b5865-7d75-4eb8-8767-2e68c33d389a",
    update = "16c1b8f7-a048-48e8-b675-222b9dcfd0d4",
    delete = "1c24a421-3099-4cab-9085-5759e62e4f99",
}
